// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"77":"8da317f2","92":"57c5067d","143":"e11edd9d","180":"c76f1978","197":"7e73483b","341":"bedc1e4f","368":"5f18ef5f","581":"1a524458","679":"d5d859ff","755":"a47b1c65","891":"7a28cab9"}[chunkId] + ".chunk.js";
};